import React from "react";
import { useNavigate } from "react-router-dom";
import { FaMinus, FaPlus } from "react-icons/fa";
import rayzor from '../../assets/images/rayzorpay.png'
import "../../assets/css/CartPage.css";
import { useCart } from "../CartContext/CartContextComp";

const AddCart = () => {
    const navigate = useNavigate();
    const { cartItems, removeFromCart, increaseQuantity, decreaseQuantity } = useCart();

    const totalAmount = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);

    const handleCheckout = () => {
        navigate("/checkout",{ state: { cartItems } });
    };

    return (
        <div className="cart-wrapper">
            <div className="cart-page">
                <button className="collection-button-back" onClick={() => navigate(-1)}>
                    &lt; Back
                </button>
                <h2 className="shopping-cart">Shopping Cart</h2>

                {cartItems.length === 0 ? (
                    <div className="empty-cart">
                        <p>Your cart is empty.</p>
                    </div>
                ) : (
                    <table className="cart-table">
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>Price</th>
                                <th>Quantity</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cartItems.map((item) => (
                                <tr key={item.id}>
                                    <td className="product-info">
                                        <img src={item.image} alt={item.name} className="cart-img" />
                                        <div>
                                            <p className="cart-product-name">{item.name}</p>
                                            <button
                                                className="remove-btn"
                                                onClick={() => removeFromCart(item.id, item.size)}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    </td>
                                    <td>Rs. {item.price.toFixed(2)}</td>
                                    <td>
                                        <div className="quantity-controls">
                                            <button onClick={() => decreaseQuantity(item.id, item.size)}>
                                                <FaMinus />
                                            </button>
                                            <span>{item.quantity}</span>
                                            <button onClick={() => increaseQuantity(item.id, item.size)}>
                                                <FaPlus />
                                            </button>
                                        </div>
                                    </td>
                                    <td>Rs. {(item.price * item.quantity).toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

            </div>

            {/* Separate Checkout Summary Section */}
            <div className="cart-summary-section">
                <div className="cart-summary">
                    <h3>Total:</h3>
                    <p className="cart-total">Rs. {totalAmount.toFixed(2)}</p>
                    <p className="cart-info">Tax included. Shipping and discounts calculated at checkout.</p>

                    <button className="checkout-btn" onClick={handleCheckout}>Check Out</button>
                </div>

                <div className="cart-info-box">
                    <h2>Delivery Information</h2>
                    <p>Free returns within 15 days, please make sure the items are in undamaged condition.</p>
                    <h2>Up to 15-Day Guarantee</h2>
                    <p>Simply contact us within 15 days of receiving your order!</p>
                    <h2>Payment Support</h2>
                    <img
                        src={rayzor}
                        alt="Payment Methods"
                        className="payment-support-img"
                    />
                </div>
            </div>
        </div>
    );
};

export default AddCart;